import type { ContestType, ContestStatus } from '@/mocks/adminContests';
import { contestTypeLabels, contestTypeIcons, contestTypeColors, contestStatusLabels } from '@/mocks/adminContests';

interface ContestFiltersProps {
  search: string;
  onSearchChange: (val: string) => void;
  selectedType: ContestType | 'todos';
  onTypeChange: (t: ContestType | 'todos') => void;
  selectedStatus: ContestStatus | 'todos';
  onStatusChange: (s: ContestStatus | 'todos') => void;
  counts: {
    todos: number;
    types: Record<string, number>;
    statuses: Record<string, number>;
  };
}

const types: (ContestType | 'todos')[] = ['todos', 'sorteo', 'trivia', 'comentarios', 'compartir', 'participacion'];
const statuses: (ContestStatus | 'todos')[] = ['todos', 'activo', 'pausado', 'proximamente', 'finalizado'];

export default function ContestFilters({ search, onSearchChange, selectedType, onTypeChange, selectedStatus, onStatusChange, counts }: ContestFiltersProps) {
  return (
    <div className="space-y-3">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="relative w-full sm:max-w-xs">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Buscar concurso..."
            className="w-full pl-9 pr-3 py-2 rounded-xl bg-background-50 border border-background-200 text-foreground-800 text-sm outline-none focus:border-primary-300 transition-colors"
          />
        </div>

        <div className="flex items-center gap-1.5 flex-wrap">
          {statuses.map((s) => (
            <button
              key={s}
              onClick={() => onStatusChange(s)}
              className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer transition-all whitespace-nowrap ${
                selectedStatus === s
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-500 border border-background-200 hover:bg-background-100'
              }`}
            >
              {s === 'todos' ? 'Todos' : contestStatusLabels[s]}
              {counts.statuses[s] !== undefined && (
                <span className={`text-[9px] ${selectedStatus === s ? 'text-white/70' : 'text-foreground-400'}`}>
                  ({counts.statuses[s]})
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-center gap-1.5 flex-wrap">
        {types.map((t) => {
          if (t === 'todos') {
            return (
              <button
                key="todos"
                onClick={() => onTypeChange('todos')}
                className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer transition-all whitespace-nowrap ${
                  selectedType === 'todos'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-50 text-foreground-500 border border-background-200 hover:bg-background-100'
                }`}
              >
                <i className="ri-apps-line text-[11px]"></i>
                Todos ({counts.todos})
              </button>
            );
          }
          const colors = contestTypeColors[t];
          return (
            <button
              key={t}
              onClick={() => onTypeChange(t)}
              className={`inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[10px] font-semibold cursor-pointer transition-all whitespace-nowrap border ${
                selectedType === t
                  ? colors.bg + ' ' + colors.text + ' ' + colors.border + ' ring-1 ring-primary-300'
                  : colors.bg + ' ' + colors.text + ' ' + colors.border + ' opacity-65 hover:opacity-100'
              }`}
            >
              <i className={`${contestTypeIcons[t]} text-[10px]`}></i>
              {contestTypeLabels[t]}
              {counts.types[t] !== undefined && (
                <span className="opacity-60">({counts.types[t]})</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}